import React from "react";
import ExpandableStatusList from "../../commonComponents/ExpandableStatusList";
import SummaryCard from "../../commonComponents/SummaryCard";

const OpportunitySalesDrawerContent = ({ statuses = [], total = 0 }) => {
  return (
    <div>
      <SummaryCard label="Total opportunity" value={total} className="mb-8" />

      {/* Expandable status list */}
      <ExpandableStatusList
        data={statuses}
        columns={[{ key: "count", label: "No. of Opportunity" }]}
        statusLabel="Status"
      />
    </div>
  );
};

export default OpportunitySalesDrawerContent;
